module.exports = __webpack_public_path__ + "41f84a7255b8d8336a8d36c91cc779fd.png";